import { RECEIVE_ECOBIO_MODALITIES, RECEIVE_ECOBIO_TAXON_TRAITS, RECEIVE_ALL_ECOBIO_TAXON_TRAITS, RECEIVE_ECOBIO_TRAITS, RECEIVE_QUALITOMETER_BY_TAXON, RECEIVE_TAXON, RECEIVE_TAXONS, RESET_TAXON } from '../constants/TaxonConstant'
import QualitometerListDto from '../dto/QualitometerListDto'
import TaxonDtoLight from '../dto/TaxonDtoLight'

export function TaxonReducer(state = {}, action) {
    switch (action.type) {
        case RECEIVE_TAXONS:
            return {
                ...state,
                taxons: action.taxons.map(t => new TaxonDtoLight(t)),
            }
        case RECEIVE_TAXON:
            return {
                ...state,
                taxon: action.taxon,
            }
        case RECEIVE_QUALITOMETER_BY_TAXON:
            return {
                ...state,
                qualitometers: action.qualitometers.map(q => new QualitometerListDto(q)),
            }
        case RECEIVE_ECOBIO_TRAITS:
            return {
                ...state,
                ecobioTraits: action.ecobioTraits,
            }
        case RECEIVE_ECOBIO_MODALITIES:
            return {
                ...state,
                ecobioModalities: action.ecobioModalities,
            }
        case RECEIVE_ECOBIO_TAXON_TRAITS:
            return {
                ...state,
                ecobioTaxonTraits: action.ecobioTaxonTraits,
            }
        case RECEIVE_ALL_ECOBIO_TAXON_TRAITS:
            return {
                ...state,
                allEcobioTaxonTraits: action.allEcobioTaxonTraits,
            }
        case RESET_TAXON:
            return {
                ...state,
                taxon: {},
            }
        default:
            return state
    }
}

export const store = {
    taxon: {},
    taxons: [],
    taxonsIndex: {},
    qualitometers: [],
    ecobioTraits: [],
    ecobioModalities: [],
    ecobioTaxonTraits: [],
    allEcobioTaxonTraits: [],
}